import * as pdfjsLib from 'pdfjs-dist/webpack';

const synonyms = {
  "Marmoraggressiv kolsyra": ["Marmoraggressiv", "kolsyra"],
  "Nitrat (NO3)": ["Nitrat"],
  "Hårdhet": ["Totalhårdhet"],
  "Kalcium (Ca)": ["Kalcium Ca (end surgjort)"],
  "Järn (Fe)": ["Järn Fe (end surgjort)"],
  "Mangan (Mn)": ["Mangan", "Mn", "Mangan Mn (end surgjort)"],
  "Arsenik (As)": ["Arsenik As (end surgjort)"],
  "Uran (U)": ["Uran", "(U)", "Uran U (end surgjort)"],
  "Ammonium": ["Ammonium", "NH4"],
  "Temperatur vid pH-mätning": ["temperatur", "pH-mätning"],
  "pH": ["pH"],
  "Färg (410 nm)": ["Färg", "410 nm"],
  "Nitrit (NO2)": ["Nitrit", "NO2"],
  "Natrium (Na)": ["Natrium", "(Na)"],
  "Klorid": ["Klorid", "Cl"],
  "Koliforma bakterier": ["bakterier"],
  "Escherichia coli": ["coli", "escherichia"],
  "Odlingsbara mikroorganismer": ["odlingsbara", "mikroorganismer"],
};

const handleFileChange = async (file, setAnalysisData, setError) => {
  try {
    const fullText = await extractTextFromFile(file);
    const parameters = [
      "Lukt", "Färg (410 nm)", "pH", "Temperatur vid pH-mätning", "Radon", "COD-Mn", "Nitrat (NO3)", "Nitrit (NO2)", "Hårdhet", "Natrium (Na)", "Alkalinitet",
      "Kalcium (Ca)", "Järn (Fe)", "Mangan (Mn)", "Arsenik (As)", "Uran (U)", "Fluorid",
      "Ammonium", "Konduktivitet", "Koliforma bakterier", "Escherichia coli", "Odlingsbara mikroorganismer", "Marmoraggressiv kolsyra", "Turbiditet", "Klorid"
    ];

    const extractedData = extractParametersAndValues(fullText, parameters, synonyms);

    if (isDataValid(extractedData, parameters)) {
      setAnalysisData(prevAnalysisData => {
        return prevAnalysisData.map(item => {
          if (extractedData[item.Analys]) {
            return { ...item, Resultat: extractedData[item.Analys] };
          }
          return item;
        });
      });
      setError(null);
    } else {
      setError("Den uppladdade filen är inte kompatibel, försök med en annan fil.");
    }
  } catch (error) {
    console.error("Error processing file:", error);
    setError("Ett fel inträffade när filen bearbetades. Se till att filen är en giltig PDF.");
  }
};

const minimumRequiredParameters = 10;

const isDataValid = (extractedData, parameters) => {
  const count = parameters.reduce((acc, param) => acc + (extractedData.hasOwnProperty(param) ? 1 : 0), 0);
  return count >= minimumRequiredParameters;
};

const extractParametersAndValues = (fullText, parameters, synonyms) => {
  let normalizedText = fullText.replace(/[\s]+/g, ' ');
  const extractedValues = {};

  parameters.forEach(parameter => {
    const allPossibleNames = [parameter, ...(synonyms[parameter] || [])];

    allPossibleNames.some(name => {
      let regex;
      let match;

      if (parameter === "Lukt") {
        regex = new RegExp(`(Ingen)?\\s*\\b${name}\\b`, 'i');
      } else if (parameter === "Järn (Fe)") {
        regex = new RegExp(`(\\d+\\.?\\d*)\\s+(?=\\b${name}\\s*\\(end surgjort\\))`, 'i');
      } else {
        regex = new RegExp(`(\\d+\\.?\\d*)\\s+(?=\\b${name}\\b)`, 'i');
      }

      match = normalizedText.match(regex);

      if (match && match[1] !== undefined) {
        extractedValues[parameter] = match[1].trim();
        return true;
      }

      return false;
    });

    if (!(parameter in extractedValues)) {
      console.log(`No value found for ${parameter}`);
    }
  });

  return extractedValues;
};

const extractTextFromFile = async (file) => {
  try {
    const pdf = await pdfjsLib.getDocument(URL.createObjectURL(file)).promise;
    let allText = '';
    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const textContent = await page.getTextContent();
      const pageTextItems = textContent.items.map(item => item.str).join(' ');
      allText += pageTextItems + '\n';
    }
    return allText;
  } catch (error) {
    console.error("Error extracting text from file:", error);
    throw error;
  }
};

export { handleFileChange };
